<div *ngIf="videoShowing" class="fixed top-0 left-0 z-[2001] grid h-screen w-screen grid-cols-1 grid-rows-1">
  <div
    class="z-70 col-start-1 col-end-1 row-start-1 row-end-1 h-full w-full bg-black p-10 opacity-80"
    (click)="closeVideo()"></div>
  <div class="col-start-1 col-end-1 row-start-1 row-end-1 mt-6 mr-10 flex items-start justify-end text-white">
    <svg
      (click)="closeVideo()"
      class="z-90 h-10 w-10 cursor-pointer stroke-current"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
    </svg>
  </div>
  <div
    (click)="closeVideo()"
    class="z-80 col-start-1 col-end-1 row-start-1 row-end-1 flex h-full w-full flex-row items-center justify-center">
    <div #videoContainer class="w-full max-w-6xl p-6 flex items-center justify-center" *ngIf="!videoError">
      <div class="text-2xl text-white flex items-center">
        <span class="loader"></span>
        Caricamento...
      </div>
    </div>
    <div *ngIf="videoError" class="h-full w-full items-center justify-center p-24 text-3xl font-semibold text-white">
      Video caricato ma non ancora disponibile perché in fase di elaborazione.<br />Riprovare tra qualche minuto.
    </div>
  </div>
</div>
